import { useRecoilValue } from "recoil";
import { authAtom } from "state/auth";

let _permission = [];

export const setAuthPermission = (permission) => {
  _permission = Array.isArray(permission) ? permission : [];
};

export const useCheckForbidden = () => {
  const { permission } = useRecoilValue(authAtom);
  return (role) => permission.includes(role);
};

export const checkForbiddenWithPermission = (permission, role) => {
  return permission.includes(role);
};

export const checkForbidden = (role) => {
  return _permission.includes(role);
};
